import { Box, Indent } from "@stenajs-webui/core";
import {
  BreadCrumbs,
  FlatButton,
  stenaBusinessNslh,
  stenaPrint,
} from "@stenajs-webui/elements";
import { SwitchWithLabel } from "@stenajs-webui/forms";
import { cssColor } from "@stenajs-webui/theme";
import React from "react";
import { ZIndex } from "@/lib/utils/ZIndexEnum";
import { Crumb } from "../../bread-crumbs/Crumb";
import { PageHeader } from "@/components/page-header/PageHeader";

interface Props {
  pageHeading: string;
  breadCrumbLabel?: string;
  previousRoute: string;
  setExcludedBookings?: () => void;
  excludedBookings?: boolean;
}

export const ViewSpecificationScreenHeader: React.FC<Props> = ({
  pageHeading,
  breadCrumbLabel,
  setExcludedBookings,
  excludedBookings,
  previousRoute,
}) => {
  const createPrintPdf = () => {
    window.print();
  };

  return (
    <Box
      position={"sticky"}
      top={0}
      left={0}
      width={"100vw"}
      zIndex={ZIndex.lowest}
      className={"view-specification-header"}
    >
      <PageHeader
        title={pageHeading}
        icon={stenaBusinessNslh}
        contentRight={
          <>
            {setExcludedBookings && (
              <>
                <SwitchWithLabel
                  label={"Show excluded bookings"}
                  value={excludedBookings}
                  onValueChange={setExcludedBookings}
                />
                <Indent />
              </>
            )}

            <FlatButton
              leftIcon={stenaPrint}
              label={"Print"}
              onClick={createPrintPdf}
            />
          </>
        }
        breadcrumbs={
          <BreadCrumbs>
            <Crumb label={"Follow up"} path={previousRoute} />
            <Crumb label={breadCrumbLabel ?? "Invoice Specification"} />
          </BreadCrumbs>
        }
      />
    </Box>
  );
};
